<div class="d-flex align-items-center mb-1 mt-4" 
     style="cursor: pointer; margin-top: -10px;" 
     (click)="regresar()">
    <mat-icon class="txt-secundario mb-0">first_page</mat-icon>
    <p class="txt-secundario mb-0 ml-2" style="font-weight: 600;">Regresar</p>
</div>

